/*jslint node: true, browser: true*/

"use strict";

var ko = require("pli/knockout");
var numberUtil = require("pli/util/number");
var pli = require("pli/forms");
var pliObservable = require("pli/forms-knockoutcontrols");

var dataCache = require("../datacache");
var entityRegistry = require("../entity-registry");

//-------------------------------------------
function extractNumber(record, name) {
    var value = record && record[name];
    return (numberUtil.isNumber(value) ? value : null);
}


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// RentalInformation class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function RentalInformation(factories) {
    /// <summary>
    /// Create a new RentalInformation object,
    /// populating it with values from the specified
    /// record (if any).
    /// </summary>
    if (!(this instanceof RentalInformation)) { return new RentalInformation(factories); } // if new was not used, force it now
    if (window.console && window.console.group) { window.console.log("RentalInformation.ctor()", factories); }

    this.amount = pliObservable(null, "C2", "numeric");
    this.firstRent = pliObservable(null, null, "date");
    this.frequency = pliObservable("Annual", dataCache.getObservable("rentalFrequency"), "picklist");
    this.payor = pliObservable(null, entityRegistry.contact.getPicklistBehaviourData(), "picklist");
    this.unitOfMeasure = pliObservable(null, dataCache.getObservable("rentalUnitOfMeasure"), "picklist");

    // non-serialized properties
    this.extras = function RentalInformationExtras() { return; };
    this.extras.errorsCount = ko.computed(factories.computeErrorsCount, this);
    this.extras.gross = ko.observable(null);
    this.extras.totalGross = ko.observable(null);
    this.extras.totalNet = ko.observable(null);
    this.extras.totalPercentage = ko.observable(null);
    this.extras.totalPercentage.invalid = ko.computed(this._computeTotalPercentageInvalid, this.extras.totalPercentage);
    this.extras._totalPercentageInvalid = this.extras.totalPercentage.invalid; // store in extras field to ensure disposal

    this.extras._amountSubscription = this.amount.subscribe(function (newValue) {
        if ((newValue === 0 || newValue === null) && !this.unitOfMeasure()) {
            // Clean error message that comes from server-side validation 
            this.unitOfMeasure.validate();
        }
    }, this);

    this.extras.gross.currency = ko.pureComputed(function () {
        return numberUtil.formatNumber(this.extras.gross(), 'C2');
    }, this);

    this.extras.totalNet.currency = ko.pureComputed(function () {
        return numberUtil.formatNumber(this.extras.totalNet(), 'C2');
    }, this);

    this.extras.totalPercentage.precision = ko.pureComputed(function () {
        return numberUtil.formatNumber(this.extras.totalPercentage(), pli.config.editorPrecisionPercentFormat);
    }, this);
}


//---------------------------------------
RentalInformation.prototype.applyServerCalculationResult = function applyResultToRental(context) {
    var record = context.currentData;
    this.extras.gross(extractNumber(record, "gross"));
    this.extras.totalGross(extractNumber(record, "totalGross"));
    this.extras.totalNet(extractNumber(record, "totalNet"));
    this.extras.totalPercentage(extractNumber(record, "totalPercentage"));
};


//---------------------------------------
RentalInformation.prototype.buildServerCalculationData = function buildDataForRental() {
    return {
        amount: this.amount(),
        payor: this.payor(),
        unitOfMeasure: this.unitOfMeasure()
    };
};


//-------------------------------------------
RentalInformation.prototype.loadViewModel = function loadRentalInformation(record) {
    if (window.console && window.console.group) { window.console.log("RentalInformation.load", record); }

    if (!record) { record = {}; }

    this.firstRent.load(record.firstRent);
    this.amount.load(record.amount);
    this.frequency.load(record.frequency || "Annual");
    this.payor.load(record.payor);
    this.unitOfMeasure.load(record.unitOfMeasure);
};


//---------------------------------------
RentalInformation.prototype._computeTotalPercentageInvalid = function computeTotalPercentageInvalid() {
    var totalPercentage = this(),
    // Calculate the delta used for javascript floating point precision problem
    // using the decimal precision settings
    // http://stackoverflow.com/questions/588004/is-floating-point-math-broken
        precision = pli.config.editorPrecision || 5,
        delta = Math.pow(10, -(precision + 1));

    return (totalPercentage !== null && Math.abs(100 - totalPercentage) > delta);
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

module.exports = RentalInformation;



//////////////////
// WEBPACK FOOTER
// ./app/lease-rentalinformation/leaseRentalInformationViewModel.js
// module id = 656
// module chunks = 49